import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { ImageUrlService } from '@core/services/assets-S3/image-url.service';

@Component({
  selector: 'app-payment-brands',
  standalone: true,
  imports: [CommonModule],
  template: `
    @for (item of paymentBrands; track $index) {
      <figure>
        <picture>
          <img [src]="item.image" [alt]="item.title" />
        </picture>
      </figure>
    }
  `,
  styles: `
    figure:last-child {
      margin-bottom: 10px;
    }
  `,
})
export class PaymentBrandsComponent {
  paymentBrands = [
    {
      title: 'Mercado Pago',
      image: 'conteudo/img/pagamentos/mercado-pago-icon.webp',
    },
    {
      title: 'Bandeiras de cartão de crédito aceitas',
      image: 'conteudo/img/pagamentos/card-brands-logo.webp',
    },
  ];

  constructor(private imageService: ImageUrlService) {
    this.paymentBrands.forEach(item => {
      item.image = `${this.imageService.getImageUrl(item.image)}`;
    });
  }
}
